import { render } from "./SSO.vue?vue&type=template&id=13f1386b"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"

import "./SSO.vue?vue&type=style&index=0&id=13f1386b&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__